import React from "react";
import DatePicker from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";

import "react-datepicker/dist/react-datepicker.css";
import { Controller } from "react-hook-form";
import "./styles.css";

const DatePickerInputV1 = ({
	label,
	id,
	placeholder,
	control,
	errors,
	showTime,
	dateFormat,
	autoFocus = false,
	className,
	// popperPlacement = "bottom-start", // Add a new prop for popper placement
}) => {
	return (
		<div className={`input-box  ${className}`}>
			<label htmlFor={id}>{label}</label>
			<Controller
				name={id}
				control={control}
				defaultValue={null} // Valor inicial como null ou uma data válida, se necessário
				render={({ field: { onChange, value } }) => (
					<DatePicker
						// className={`border ${errors[id] ? "error" : ""}`}
						// className={` ${errors[id] ? "error" : ""}`}
						className={`datepicker-input ${errors[id] ? "error" : ""}`}
						id={id}
						selected={value} // Usamos o valor controlado pelo react-hook-form
						onChange={(date) => onChange(date)} // Atualiza o valor do campo no formulário
						showTimeSelect={showTime}
						timeFormat="HH:mm:ss"
						timeIntervals={15}
						dateFormat={showTime ? "dd/MM/yyyy HH:mm:ss" : "dd/MM/yyyy"}
						timeCaption="Hora"
						locale={ptBR}
						placeholderText={placeholder}
						autoFocus={autoFocus}
						// popperPlacement={popperPlacement} // Use the new prop
					/>
				)}
			/>
			{errors[id] && <p className="errors">{errors[id].message}</p>}
		</div>
	);
};

export default DatePickerInputV1;
